import { Sparkles } from 'lucide-react';
import { useI18n } from '../../../context/useI18n';
import './SpiritualHomeButton.css';

export default function SpiritualHomeButton({ onOpen }) {
  const { t } = useI18n();

  return (
    <div className="spiritual-home-btn-wrap">
      <button
        type="button"
        className="spiritual-home-btn"
        onClick={onOpen}
        aria-label={t('spiritual.open_aria', 'Abrir Viento Recio')}
      >
        <Sparkles className="spiritual-home-btn__icon h-4 w-4" aria-hidden />
        <span className="spiritual-home-btn__label">{t('nav.spiritual', 'Viento Recio')}</span>
        <span className="spiritual-home-btn__hint">{t('spiritual.home_hint', 'Biblia · Devocional · Hoy')}</span>
      </button>
    </div>
  );
}
